import { render, staticRenderFns } from "./list-general.vue?vue&type=template&id=a786d76a"
import script from "./list-general.vue?vue&type=script&lang=js"
export * from "./list-general.vue?vue&type=script&lang=js"
import style0 from "./list-general.vue?vue&type=style&index=0&id=a786d76a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports